/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dialog, DialogContent } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import createIcon from '../../../../assets/images/feather-settings.svg';
import {
  getRebateProgramCode,
  getAddressTypeCode,
  searchMailingRequestAction,
  handleHeaderErrorMessages,
  handleFieldLevelErrMsg,
  getManufacturerRequestMailing,
  getCountOfAllMfgLabelsReqLabel,
  getCountOfAllFilteredMfgLabelsReqLabel,
  dispatcCountAllMfgLabels,
  dispatchCountAllFilteredMfgLabels,
  getAllMfgLabelsReqLabel,
  dispatchAllMfgLabels,
  dispatchAllManufacturerRequestMailing,
} from '../store/actions';
import {
  ADDRESS_TYPE_REQUIRED,
  REBATE_PROGRAM_REQUIRED_REQ,
  COPIES_REQUIRED,
  DATE_INVALID_REQUEST_MAILING,
  SELECT_MANUFACTURER,
  REQ_MAILING_CONTINUE,
  PRINT_REQ_MAILING,
  REQ_MAILING_NO_MANUFACTURER,
} from '../../../../SharedModules/Errors/constantMessageData';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  convertPDFFromAPI,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { manuFactureHead } from './gridComponents/tableHead';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
  dateFormatDatePicker,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

function RequestInvoiceDetails(props) {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = today.getMonth() + 1; // Months start at 0!
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const currDate = `${mm}/${dd}/${yyyy}`;
  const dispatch = useDispatch();
  const [errorMessages, setErrorMessages] = useState([]);
  const [filterValue, setFilterValue] = useState({
    planType: 'FD',
    rebateProgramCode: '-1',
    addressTypeCode: '-1',
    copies: 1,
    manufacturer: 'All',
    invoiceMailedDate: '',
  });

  const [showError, setShowError] = React.useState({});
  const [showDateError, setShowDateError] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [openDialogLabels, setOpenDialogLabels] = useState(false);

  const [tableData, settableData] = React.useState([]);
  const [countMfgLabel, setCountMgfLabel] = React.useState('');
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [rebateProCd, setRebateProCd] = useState([]);
  // const [showError, setShowError] = useState(false);
  const [columnDefs, setColumnDefs] = useState(manuFactureHead);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const selectedClient = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.selectedClient
  );
  const searchRequestMailing = useSelector(
    (state) => state?.sharedState?.RequestMailingReducer?.searchRequestMailing
  );
  const errorMessagesInRedux = useSelector(
    (state) => state?.sharedState?.RequestMailingReducer?.errorMessagesInRedux
  );
  const fieldLevelErrMsgInRedux = useSelector(
    (state) => state?.sharedState?.RequestMailingReducer?.fieldLevelErros
  );
  // const [showError, setShowError] = React.useState(fieldLevelErrMsgInRedux);
  React.useEffect(() => {
    setShowError(fieldLevelErrMsgInRedux);
  }, [fieldLevelErrMsgInRedux]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  React.useEffect(() => {
    getUserDefaultValues(logInUser);
  }, []);

  React.useEffect(() => {
    if (searchRequestMailing?.planType == '')
      dispatch(
        searchMailingRequestAction({
          ...searchRequestMailing,
          planType: UserDefaultValues?.planTypeCd || 'FD',
          rebateProgramCode: UserDefaultValues?.rebateProgramCd || '-1',
        })
      );
  }, [UserDefaultValues]);

  const getAddressTypeCodeValue = () => dispatch(getAddressTypeCode());
  const addressTypeCode = useSelector(
    (state) =>
      state.sharedState.RequestMailingReducer?.addressTypeCode?.addressTypes
  );

  const getManufacturerRequestMailingValue = (values) =>
    dispatch(getManufacturerRequestMailing(values));
  const getManufacturerDetailsRequest = useSelector(
    (state) =>
      state.sharedState.RequestMailingReducer?.getManufacturerDetailsRequest
        ?.manufacturers
  );
  const getCountOfAllMfgLabelsReqLabelValue = (values) =>
    dispatch(getCountOfAllMfgLabelsReqLabel(values));
  const getCountOfAllMfgLabelsValue = useSelector(
    (state) =>
      state.sharedState.RequestMailingReducer?.getCountOfAllMfgLabelsReq
        ?.labelCount
  );
  const getCountOfAllFilteredMfgLabelsReqLabelValue = (values) =>
    dispatch(getCountOfAllFilteredMfgLabelsReqLabel(values));
  const getCountOfAllFilteredMfgLabelsValue = useSelector(
    (state) =>
      state.sharedState.RequestMailingReducer?.getCountOfAllFilteredMfgLabelsReq
        ?.labelCount
  );

  const getAllMfgLabelsReqLabelValue = (values) =>
    dispatch(getAllMfgLabelsReqLabel(values));
  const getAllMfgLabelsValue = useSelector(
    (state) => state.sharedState.RequestMailingReducer?.getAllMfgLabelsReq
  );

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const handelCancelClose = () => {
    setOpenDialogLabels(false);
    dispatch(dispatcCountAllMfgLabels(''));
    dispatch(dispatchCountAllFilteredMfgLabels(''));
  };

  const onChangeDateField = (d, name) => {
    if (d != 'Invalid Date') {
      setShowDateError(false);
      dispatch(
        searchMailingRequestAction({
          ...searchRequestMailing,
          [name]: d,
        })
      );
      const formErr = {
        ...fieldLevelErrMsgInRedux,
        [name]: false,
      };
      dispatch(handleFieldLevelErrMsg(formErr));
      setShowError(formErr);
      const formError = {
        ...fieldLevelErrMsgInRedux,
        dateError: false,
      };
      dispatch(handleFieldLevelErrMsg(formError));
      if (errorMessagesInRedux.length > 0) {
        const errorMsg = [];
        const error = errorMessagesInRedux.map((item) => {
          if (item != DATE_INVALID_REQUEST_MAILING) {
            return errorMsg.push(item);
          }
        });
        dispatch(handleHeaderErrorMessages(errorMsg));
      }
    }
  };
  const handleInvoiceSearch = (e) => {
    if (e?.target.name != 'copies')
      dispatch(
        searchMailingRequestAction({
          ...searchRequestMailing,
          [e?.target.name]: e?.target.value,
          ...('planType' in searchRequestMailing &&
            e?.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );

    const regexNumber = /^\d*$/;
    if (
      e?.target.name == 'copies' &&
      regexNumber.test(e.target.value) &&
      e.target.value.length < 4 &&
      e.target.value != '0'
    ) {
      dispatch(
        searchMailingRequestAction({
          ...searchRequestMailing,
          [e?.target.name]: e?.target.value,
          ...('planType' in searchRequestMailing &&
            e?.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );
    }
    if (e?.target.name !== 'copies') {
      dispatch(
        searchMailingRequestAction({
          ...searchRequestMailing,
          [e?.target.name]: e?.target.value,
          ...('planType' in searchRequestMailing &&
            e?.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );
    }
    if (e?.target.value == 'SM' && e?.target.name == 'manufacturer') {
      const data = {
        planTypeCd: searchRequestMailing.planType,
      };
      getManufacturerRequestMailingValue(data);
      if (errorMessagesInRedux.length > 0) {
        const errorMsg = [];
        const error = errorMessagesInRedux.map((item) => {
          if (
            item != SELECT_MANUFACTURER &&
            item != DATE_INVALID_REQUEST_MAILING
          ) {
            return errorMsg.push(item);
          }
        });
        dispatch(handleHeaderErrorMessages(errorMsg));
        const formErr = {
          ...fieldLevelErrMsgInRedux,
          dateError: false,
        };
        setShowDateError(false);
        dispatch(handleFieldLevelErrMsg(formErr));
        dispatch(
          searchMailingRequestAction({
            ...searchRequestMailing,
            [e?.target.name]: e?.target.value,
            invoiceMailedDate: currDate,
          })
        );
        if (errorMsg?.length > 0) {
          tabHighLigher(true);
        } else {
          tabHighLigher(false);
        }
      }
    } else if (
      e?.target.name == 'planType' &&
      searchRequestMailing.manufacturer == 'SM'
    ) {
      const data = {
        planTypeCd: e?.target.value,
      };
      getManufacturerRequestMailingValue(data);
    } else if (e?.target.name == 'manufacturer' && e?.target.value != 'SM') {
      if (errorMessagesInRedux.length > 0) {
        const errorMsg = [];
        const error = errorMessagesInRedux.map((item) => {
          if (
            item != SELECT_MANUFACTURER &&
            item != DATE_INVALID_REQUEST_MAILING
          ) {
            return errorMsg.push(item);
          }
        });
        dispatch(handleHeaderErrorMessages(errorMsg));
        const formErr = {
          ...fieldLevelErrMsgInRedux,
          dateError: false,
        };
        setShowDateError(false);
        dispatch(handleFieldLevelErrMsg(formErr));
        dispatch(
          searchMailingRequestAction({
            ...searchRequestMailing,
            [e?.target.name]: e?.target.value,
            invoiceMailedDate: currDate,
          })
        );
        if (errorMsg.length > 0) {
          tabHighLigher(true);
        } else {
          tabHighLigher(false);
        }
      }
    }
  };
  React.useEffect(() => {
    if (
      getManufacturerDetailsRequest &&
      getManufacturerDetailsRequest.length > 0
    ) {
      const newObj = getManufacturerDetailsRequest?.map((item) => {
        item.value = item.value ? item.value : false;
        return item;
      });
      settableData(newObj);
    }
  }, [getManufacturerDetailsRequest]);

  React.useEffect(() => {
    const count =
      getCountOfAllMfgLabelsValue || getCountOfAllMfgLabelsValue == 0
        ? getCountOfAllMfgLabelsValue.toString()
        : '';
    if (count && count != '') {
      setCountMgfLabel(count);
      setOpenDialogLabels(true);
    } else if (count && count == '0') {
      setCountMgfLabel(count);
      setOpenDialogLabels(true);
    }
  }, [getCountOfAllMfgLabelsValue]);
  React.useEffect(() => {
    const count =
      getCountOfAllFilteredMfgLabelsValue ||
      getCountOfAllFilteredMfgLabelsValue == 0
        ? getCountOfAllFilteredMfgLabelsValue.toString()
        : '';
    if (count && count != '') {
      setCountMgfLabel(count);
      setOpenDialogLabels(true);
    } else if (count && count == '0') {
      setCountMgfLabel(count);
      setOpenDialogLabels(true);
    }
  }, [getCountOfAllFilteredMfgLabelsValue]);

  React.useEffect(() => {
    if (getAllMfgLabelsValue && getAllMfgLabelsValue != '') {
      setSpinnerLoader(false);
      setOpenDialogLabels(false);
      convertPDFFromAPI(getAllMfgLabelsValue);
      dispatch(dispatchAllMfgLabels(''));
    }
  }, [getAllMfgLabelsValue]);

  const validateDateFormatOnBlur = (event, type) => {
    const errorMessages = [];
    const regex = new RegExp(/^[0-9/]+$/);
    const invoiceDate = event.target.value;
    const sptDate =
      invoiceDate && invoiceDate.includes('_')
        ? invoiceDate.split('_')
        : invoiceDate;
    const splitDate =
      sptDate && sptDate.length > 0 && sptDate[0].includes('/')
        ? sptDate[0].split('/')
        : sptDate;
    if (searchRequestMailing.manufacturer === 'IN' && invoiceDate === '') {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (
      searchRequestMailing.manufacturer === 'IN' &&
      sptDate[0] &&
      !regex.test(sptDate[0])
    ) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2].length == 1 || splitDate[0] > 12)
    ) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2] == 0 || splitDate[1] == 0 || splitDate[0] == 0)
    ) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2].length == 3 || splitDate[2].length == 1)
    ) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (
      splitDate.length == 2 &&
      (splitDate[1].length == 1 || splitDate[0] > 12)
    ) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (splitDate.length == 2 && (splitDate[1] == 0 || splitDate[0] == 0)) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (invoiceDate && splitDate.length == 1) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
    }
    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      setShowDateError(true);
      const errMsg = [...errorMessagesInRedux, ...new Set(errorMessages)];
      dispatch(handleHeaderErrorMessages(errMsg));
      tabHighLigher(true);
      dispatch(
        searchMailingRequestAction({
          ...searchRequestMailing,
          invoiceMailedDate: invoiceDate,
        })
      );
      return false;
    } else {
      setErrorMessages([]);
      setShowDateError(false);
      if (errorMessagesInRedux.length > 0) {
        const errorMsg = [];
        const error = errorMessagesInRedux.map((item) => {
          if (item != DATE_INVALID_REQUEST_MAILING) {
            return errorMsg.push(item);
          }
        });
        dispatch(handleHeaderErrorMessages(errorMsg));
      } else {
        tabHighLigher(false);
      }
      let finalDate;
      const inDate = event.target.value;
      const sptDate =
        invoiceDate && invoiceDate.includes('_')
          ? invoiceDate.split('_')
          : invoiceDate;
      const invDate =
        sptDate && sptDate.length > 0 && sptDate[0].includes('/')
          ? sptDate[0].split('/')
          : sptDate;
      const dateLength = invDate.length;
      if (dateLength == 2 && invDate[1].length == 2) {
        const years2D =
          invDate[1].length == 2 && invDate[1] < 43
            ? `20${invDate[1]}`
            : `19${invDate[1]}`;
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/` + '01' + `/${years2D}`;
        dispatch(
          searchMailingRequestAction({
            ...searchRequestMailing,
            invoiceMailedDate: finalDate,
          })
        );
      }
      if (dateLength == 2 && invDate[1].length == 4) {
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/` + '01' + `/${invDate[1]}`;
        dispatch(
          searchMailingRequestAction({
            ...searchRequestMailing,
            invoiceMailedDate: finalDate,
          })
        );
      }
      if (dateLength == 3 && invDate[2].length == 2) {
        const years2D =
          invDate[2].length == 2 && invDate[2] < 43
            ? `20${invDate[2]}`
            : `19${invDate[2]}`;
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/${invDate[1]}/${years2D}`;
        dispatch(
          searchMailingRequestAction({
            ...searchRequestMailing,
            invoiceMailedDate: finalDate,
          })
        );
      }
      if (dateLength == 3 && invDate[2].length == 4) {
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        const day = invDate[1].length < 2 ? `0${invDate[1]}` : invDate[1];
        finalDate = `${month}/${day}/${invDate[2]}`;
        dispatch(
          searchMailingRequestAction({
            ...searchRequestMailing,
            invoiceMailedDate: finalDate,
          })
        );
      }
      testValidDate(invDate);
    }
  };
  function testValidDate(s) {
    if (!/^\d\d\/\d\d\/\d\d\d\d$/.test(s)) {
      return false;
    }
    const parts = s.split('/').map((p) => parseInt(p, 10));
    parts[0] -= 1;
    dispatch(
      searchMailingRequestAction({
        ...searchRequestMailing,
        invoiceMailedDate: s,
      })
    );
    const d = new Date(parts[2], parts[0], parts[1]);
    const result =
      d.getMonth() === parts[0] &&
      d.getDate() === parts[1] &&
      d.getFullYear() === parts[2];
    if (result) {
      setErrorMessages([]);
      setShowDateError(false);
      return true;
    }
    if (errorMessagesInRedux.length > 0) {
      const errorMsg = [];
      const error = errorMessagesInRedux.map((item) => {
        if (item != DATE_INVALID_REQUEST_MAILING) {
          return errorMsg.push(item);
        }
      });
      errorMsg.push(DATE_INVALID_REQUEST_MAILING);
      dispatch(handleHeaderErrorMessages(errorMsg));
    } else {
      const errorMsg = [];
      errorMsg.push(DATE_INVALID_REQUEST_MAILING);
      dispatch(handleHeaderErrorMessages(errorMsg));
    }
    tabHighLigher(true);
    setShowDateError(true);
    const formErr = {
      ...fieldLevelErrMsgInRedux,
      dateError: true,
    };
    dispatch(handleFieldLevelErrMsg(formErr));
    return false;
  }
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    const errorMessagesRedux = [...errorMessagesInRedux];
    const errors = { ...fieldLevelErrMsgInRedux };
    if (type === 'rebateProgramCode' && (value === '-1' || value === '')) {
      errorMessagesRedux.push(REBATE_PROGRAM_REQUIRED_REQ);
      errors.reqRebateCodeErr = true;
    } else if (type === 'rebateProgramCode' && value !== '-1' && value !== '') {
      errorMessagesRedux &&
        errorMessagesRedux.length > 0 &&
        errorMessagesRedux.forEach((item, key) => {
          if (item === REBATE_PROGRAM_REQUIRED_REQ) {
            return errorMessagesRedux.splice(key, 1);
          }
        });
      errors.reqRebateCodeErr = false;
    }
    if (type === 'addressTypeCode' && (value === '-1' || value === '')) {
      errorMessagesRedux.push(ADDRESS_TYPE_REQUIRED);
      errors.reqAddressTypeErr = true;
    } else if (type === 'addressTypeCode' && value !== '-1' && value !== '') {
      errorMessagesRedux &&
        errorMessagesRedux.length > 0 &&
        errorMessagesRedux.forEach((item, key) => {
          if (item === ADDRESS_TYPE_REQUIRED) {
            return errorMessagesRedux.splice(key, 1);
          }
        });
      errors.reqAddressTypeErr = false;
    }
    if (type === 'copies' && value === '') {
      errorMessagesRedux.push(COPIES_REQUIRED);
      errors.reqCopies = true;
    } else if (type === 'copies' && value !== '-1' && value !== '') {
      errorMessagesRedux &&
        errorMessagesRedux.length > 0 &&
        errorMessagesRedux.forEach((item, key) => {
          if (item === COPIES_REQUIRED) {
            return errorMessagesRedux.splice(key, 1);
          }
        });
      errors.reqCopies = false;
    }
    handleScrollToEvent();
    setErrorMessages(errorMessagesRedux);
    setShowError(errors);
    dispatch(handleHeaderErrorMessages(errorMessagesRedux));
    dispatch(handleFieldLevelErrMsg(errors));
  };
  const validateFormData = () => {
    const errorMessages = [];
    const errors = {
      reqRebateCodeErr: false,
      reqAddressTypeErr: false,
      reqCopies: false,
      dateError: false,
    };
    if (
      moment(searchRequestMailing.invoiceMailedDate).format('MM/DD/YYYY') ==
      'Invalid date'
    ) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
      errors.dateError = true;
    } else if (showDateError) {
      errorMessages.push(DATE_INVALID_REQUEST_MAILING);
      errors.dateError = true;
    } else {
      errors.dateError = false;
    }
    if (searchRequestMailing.rebateProgramCode === '-1') {
      errorMessages.push(REBATE_PROGRAM_REQUIRED_REQ);
      errors.reqRebateCodeErr = true;
    } else {
      errors.reqRebateCodeErr = false;
    }
    if (searchRequestMailing.addressTypeCode === '-1') {
      errorMessages.push(ADDRESS_TYPE_REQUIRED);
      errors.reqAddressTypeErr = true;
    } else {
      errors.reqAddressTypeErr = false;
    }
    if (
      searchRequestMailing.copies === '' ||
      searchRequestMailing.copies === null
    ) {
      errorMessages.push(COPIES_REQUIRED);
      errors.reqCopies = true;
    } else {
      errors.reqCopies = false;
    }
    if (searchRequestMailing.manufacturer == 'SM') {
      const sltManufacturer = onSelectManufacturerCheckBox();
      if (sltManufacturer && Object.keys(sltManufacturer).length == 0)
        errorMessages.push(SELECT_MANUFACTURER);
    }
    if (errorMessages.length > 0) {
      handleScrollToEvent();
      setErrorMessages(errorMessages);
      setShowError(errors);
      dispatch(handleHeaderErrorMessages(errorMessages));
      dispatch(handleFieldLevelErrMsg(errors));
      tabHighLigher(true);
      return false;
    }
    setErrorMessages([]);
    setShowError(errors);
    dispatch(handleHeaderErrorMessages(errorMessages));
    dispatch(handleFieldLevelErrMsg(errors));
    tabHighLigher(false);
    return true;
  };
  const onSelectManufacturerCheckBox = () => {
    let newObj = [];
    newObj =
      tableData &&
      tableData.length > 0 &&
      tableData
        .filter((x) => {
          return x.value;
        })
        .map((prop) => {
          return {
            mfgId: prop.mfgId,
            mfgName: prop.mfgName,
          };
        });
    return newObj;
  };
  const handleProcess = () => {
    if (searchRequestMailing.manufacturer !== 'SM' && validateFormData()) {
      setErrorMessages([]);
      dispatch(handleFieldLevelErrMsg({}));
      dispatch(handleHeaderErrorMessages([]));
      setShowError({});
      tabHighLigher(false);
      let newData = {};
      if (searchRequestMailing.manufacturer == 'All') {
        newData = {
          rpc: searchRequestMailing.rebateProgramCode,
          contactTypeCd: searchRequestMailing.addressTypeCode,
          alAll: '1',
          mfgIdList: [],
          copies: searchRequestMailing.copies,
        };
        getCountOfAllMfgLabelsReqLabelValue(newData);
      } else if (
        searchRequestMailing.manufacturer == 'MRC' ||
        searchRequestMailing.manufacturer == 'IN'
      ) {
        const date = searchRequestMailing.invoiceMailedDate
          ? moment(searchRequestMailing.invoiceMailedDate).format('MM-DD-YYYY')
          : '';
        newData = {
          rpc: searchRequestMailing.rebateProgramCode,
          contactTypeCd: searchRequestMailing.addressTypeCode,
          alRQ: searchRequestMailing.manufacturer == 'MRC' ? 1 : 0,
          mailingDate:
            searchRequestMailing.manufacturer == 'MRC' ? '00-00-0000' : date,
          copies: parseInt(searchRequestMailing.copies),
        };
        getCountOfAllFilteredMfgLabelsReqLabelValue(newData);
      }
    } else if (
      searchRequestMailing.manufacturer == 'SM' &&
      validateFormData()
    ) {
      const sltManufacturer = onSelectManufacturerCheckBox();
      const selectedManufacturer = [];
      const formattedData = sltManufacturer.map((item) => {
        selectedManufacturer.push(item.mfgId);
      });
      const newData = {
        rpc: searchRequestMailing.rebateProgramCode,
        contactTypeCd: searchRequestMailing.addressTypeCode,
        alAll: 0,
        mfgIdList: selectedManufacturer,
        copies: parseInt(searchRequestMailing.copies),
      };
      getCountOfAllMfgLabelsReqLabelValue(newData);
    }
  };
  const handelYesButton = () => {
    setSpinnerLoader(true);
    let newData = {};
    if (searchRequestMailing.manufacturer == 'All') {
      newData = {
        url: 'allMfg',
        req: {
          rpc: searchRequestMailing.rebateProgramCode,
          contactTypeCd: searchRequestMailing.addressTypeCode,
          alAll: '1',
          mfgIdList: [],
          copies: searchRequestMailing.copies,
        },
      };
      getAllMfgLabelsReqLabelValue(newData);
    } else if (
      searchRequestMailing.manufacturer == 'MRC' ||
      searchRequestMailing.manufacturer == 'IN'
    ) {
      const date = searchRequestMailing.invoiceMailedDate
        ? moment(searchRequestMailing.invoiceMailedDate).format('MM-DD-YYYY')
        : '';
      newData = {
        url: 'filterMfg',
        req: {
          rpc: searchRequestMailing.rebateProgramCode,
          contactTypeCd: searchRequestMailing.addressTypeCode,
          alRQ: searchRequestMailing.manufacturer == 'MRC' ? 1 : 0,
          mailingDate:
            searchRequestMailing.manufacturer == 'MRC' ? '00-00-0000' : date,
          copies: parseInt(searchRequestMailing.copies),
        },
      };
      getAllMfgLabelsReqLabelValue(newData);
    } else if (
      searchRequestMailing.manufacturer == 'SM' &&
      validateFormData()
    ) {
      const sltManufacturer = onSelectManufacturerCheckBox();
      const selectedManufacturer = [];
      const formattedData = sltManufacturer.map((item) => {
        selectedManufacturer.push(item.mfgId);
      });
      newData = {
        url: 'allMfg',
        req: {
          rpc: searchRequestMailing.rebateProgramCode,
          contactTypeCd: searchRequestMailing.addressTypeCode,
          alAll: 0,
          mfgIdList: selectedManufacturer,
          copies: parseInt(searchRequestMailing.copies),
        },
      };
      getAllMfgLabelsReqLabelValue(newData);
    }
    dispatch(dispatcCountAllMfgLabels(''));
    dispatch(dispatchCountAllFilteredMfgLabels(''));
  };

  React.useEffect(() => {
    if (searchRequestMailing.planType) {
      const rebateCd = getRebateProgramCode(searchRequestMailing.planType);
      rebateCd.then((res) => {
        setRebateProCd(res.data);
      });
    }
  }, [searchRequestMailing.planType]);

  React.useEffect(() => {
    setErrorMessages([]);
  }, [selectedClient]);

  React.useEffect(() => {
    getAddressTypeCodeValue();
  }, []);

  const frameworkComponents = {
    CheckBox: (cellInfo) => {
      return (
        <>
          <div className="tbl-checkbox frr-checkbox-no-label">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="checkbox"
              onClick={(e) => {
                const { checked } = e.target;
                const { colId } = cellInfo.column;
                cellInfo.node.setDataValue(colId, checked);
                const newObj = [...getManufacturerDetailsRequest];
                const rowIndex = newObj?.findIndex((x) => {
                  return x.mfgId === cellInfo.data.mfgId;
                });
                newObj[rowIndex].value = checked;
                dispatch(dispatchAllManufacturerRequestMailing(newObj));
              }}
              checked={cellInfo.value}
              value={cellInfo.value}
              data-testid="checkBox_selected"
            />
          </div>
        </>
      );
    },
  };

  const onSelectionChanged = useCallback(
    (val) => {
      const selectedRows = val.api.getSelectedRows();
    },
    [gridApi]
  );

  const tabHighLigher = (val) => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    const list = data.map((obj) => {
      if (obj.navTo === '/MailingLabel') {
        obj.isFormError = val;
      }
      return obj;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(list));
  };

  return (
    <div data-testid="requestMailingComponent" className="frr-request-mailing">
      <Spinner load={spinnerLoader} />
      <Dialog
        open={openDialogLabels}
        onClose={handelCancelClose}
        data-testid="handelCancelClose"
        className="multiGroupDialog custom-dialog-box dialog-420 popup-content-top-margin"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
        <DialogContent>
          <div className="custom-panel">
            <div className="panel-header">
              <span className="float-left"> Message </span>
              <span
                className="float-right"
                onClick={handelCancelClose}
                data-testid="handelClose"
              >
                <i className="fa fa-times-circle" aria-hidden="true" />
              </span>
              <div className="clearfix" />
            </div>
            {countMfgLabel != '0' ? (
              <div className="text-center px-2">
                <DialogContentText style={{ color: 'black' }}>
                  {PRINT_REQ_MAILING} {countMfgLabel} {REQ_MAILING_CONTINUE}
                </DialogContentText>
              </div>
            ) : (
              <div className="text-center px-2">
                <DialogContentText style={{ color: 'black' }}>
                  {REQ_MAILING_NO_MANUFACTURER}
                </DialogContentText>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <div className="btn-wrapper my-2">
            {countMfgLabel != '0' ? (
              <Button
                onClick={handelYesButton}
                data-testid="handelYesButton"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>
            ) : (
              ''
            )}

            <Button
              onClick={handelCancelClose}
              className="btn btn-cancel btn-primary"
              color="primary"
              autoFocus
            >
              {countMfgLabel != '0' ? (
                <SVGComponent iconName="Icon-cancel" />
              ) : (
                <SVGComponent iconName="Icon_awesome-check-circle" />
              )}
              {countMfgLabel != '0' ? 'No' : 'Ok'}
            </Button>
          </div>
        </DialogActions>
        </div>
      </Dialog>
      <div className="excludedNDCs tBillPanel padding-0">
        <div className="tabs-container frr-rml-container">
          <CustomSeparator parent1="Tasks" parent2="Request Mailing Labels" />
          <DisplayErrorMessages
            errorMessages={[...new Set(errorMessagesInRedux)]}
          />
          <div className="clearfix" />

          <div className="">
            {!fullScreenView && (
              <div className={`row mb-2 ${fullScreenView ? 'hide-form' : ''}`}>
                {/* <div className={`row mb-2`}> */}
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 frr-request-plan-type frr-radio-40per-width">
                  <fieldset
                    data-testid="radio-box-component"
                    className="radioBtnGroup custom-fieldset"
                  >
                    <legend className="same-font-family">
                      Plan Type <span className="mandatory"> *</span>
                    </legend>
                    <div className="form-wrapper db">
                      <div className="sub-radio no-margin">
                        <FormControl>
                          <RadioGroup
                            row
                            name="planType"
                            value={searchRequestMailing.planType}
                            onChange={handleInvoiceSearch}
                            data-testid="planType"
                          >
                            <FormControlLabel
                              value="FD"
                              control={<Radio />}
                              label="Medicaid"
                              data-test="Medicaid"
                              // style={{ width: '40%' }}
                            />

                            <FormControlLabel
                              value="COMM"
                              control={<Radio />}
                              label="Commercial"
                              data-test="Commercial"
                              // style={{ width: '41%' }}
                            />

                            <FormControlLabel
                              value="ST"
                              control={<Radio />}
                              label="State"
                            />

                            <FormControlLabel
                              value="SUPP"
                              control={<Radio />}
                              label="Supplemental"
                              data-test="Supplemental"
                              // style={{ width: '41%' }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-12 col-sm-8  mt-2 mt-sm-1 col-md-8 col-lg-8">
                  <fieldset
                    data-testid="radio-box-component"
                    className="radioBtnGroup custom-fieldset"
                  >
                    <legend aria-hidden="true" className="d-none" />
                    <div className="form-wrapper frr-requestmailing-dropdown">
                      <div className="mui-custom-form with-select input-md override-width-95">
                        <TextField
                          className="mandate-fields"
                          id="RebateProgram"
                          inputProps={{ id: 'RebateProgram' }}
                          label="Rebate Program:"
                          required
                          data-testid="rebateProgram"
                          fullWidth
                          select
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="rebateProgramCode"
                          value={
                            searchRequestMailing?.rebateProgramCode
                              ? searchRequestMailing.rebateProgramCode
                              : '-1'
                          }
                          onChange={handleInvoiceSearch}
                          onBlur={(e) =>
                            handleOnblurEvent(
                              'rebateProgramCode',
                              e.target.value
                            )
                          }
                          helperText={
                            showError.reqRebateCodeErr
                              ? REBATE_PROGRAM_REQUIRED_REQ
                              : null
                          }
                          error={
                            showError.reqRebateCodeErr
                              ? REBATE_PROGRAM_REQUIRED_REQ
                              : null
                          }
                        >
                          <MenuItem
                            className="frr-dropdown-blank-item"
                            selected
                            key=""
                            value="-1"
                          />
                          {rebateProCd && rebateProCd?.length > 0
                            ? rebateProCd.map((item) => {
                                return (
                                  <MenuItem
                                    key={item.rebateProgramCd}
                                    value={item.rebateProgramCd}
                                  >
                                    {item.rebateProgramCd} {'|'}{' '}
                                    {item.shortDescr}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>

                      <div className="mui-custom-form with-select input-md override-width-95">
                        <TextField
                          label="Address Type:"
                          id="AddressType"
                          inputProps={{ id: 'AddressType' }}
                          className="mandate-fields"
                          fullWidth
                          data-testid="addressTypeCode"
                          select
                          required
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="addressTypeCode"
                          value={searchRequestMailing.addressTypeCode}
                          onChange={handleInvoiceSearch}
                          onBlur={(e) =>
                            handleOnblurEvent('addressTypeCode', e.target.value)
                          }
                          helperText={
                            showError.reqAddressTypeErr
                              ? ADDRESS_TYPE_REQUIRED
                              : null
                          }
                          error={
                            showError.reqAddressTypeErr
                              ? ADDRESS_TYPE_REQUIRED
                              : null
                          }
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />
                          {addressTypeCode && addressTypeCode.length > 0
                            ? addressTypeCode.map((item) => {
                                return (
                                  <MenuItem
                                    key={item.contactTypeCd}
                                    value={item.contactTypeCd}
                                  >
                                    {item.contactTypeCd} - {item.shortDesc}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>

                      <div className="mui-custom-form with-select input-md override-width-95 frr-visible-counter-arrow ">
                        <TextField
                          label="Copies:"
                          id="Copies"
                          data-testid="copies"
                          className="mandate-fields"
                          fullWidth
                          placeholder=""
                          name="copies"
                          required
                          type="number"
                          value={searchRequestMailing.copies}
                          onChange={handleInvoiceSearch}
                          onBlur={(e) =>
                            handleOnblurEvent('copies', e.target.value)
                          }
                          inputProps={{ id: 'Copies', min: 1, max: 999 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          helperText={
                            showError.reqCopies ? COPIES_REQUIRED : null
                          }
                          error={showError.reqCopies ? COPIES_REQUIRED : null}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-12 mt-2 frr-radio-manufacturer">
                  <fieldset
                    data-testid="radio-box-component"
                    className="radioBtnGroup custom-fieldset"
                  >
                    <legend className="same-font-family">
                      Manufacturers <span className="mandatory"> *</span>
                    </legend>
                    <div className="form-wrapper db">
                      <div className="sub-radio no-margin">
                        <FormControl>
                          <RadioGroup
                            row
                            name="manufacturer"
                            defaultValue={selectedClient}
                            data-testid="manufacturer"
                            value={searchRequestMailing.manufacturer}
                            onChange={handleInvoiceSearch}
                          >
                            <FormControlLabel
                              value="All"
                              control={<Radio />}
                              label="All Manufacturers"
                              data-test="All"
                              className="frr-width-30"
                              // style={{ width: '30%' }}
                            />
                            <FormControlLabel
                              value="MRC"
                              control={<Radio />}
                              className="frr-width-65"
                              label="Manufacturers receiving an invoice in most recent complete quarter"
                              data-test="IN"
                              // style={{ width: '65%' }}
                            />
                            <FormControlLabel
                              value="SM"
                              control={<Radio />}
                              className="frr-width-31dot8"
                              label="Selected Manufacturers"
                              data-test="selected"
                              // style={{ width: '31.8%' }}
                            />
                            <FormControlLabel
                              value="IN"
                              control={<Radio />}
                              label="Manufacturers with a certain invoice mailed date"
                              data-test="invoiceDate"
                            />
                            <span className="mui-custom-form with-select field-xl mt-0 ">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  disabled={
                                    searchRequestMailing.manufacturer != 'IN'
                                  }
                                  className="mandate-fields frr-display-hidden-label"
                                  id="invoiceMailedDate"
                                  inputProps={{ id: 'invoiceMailedDate' }}
                                  label="invoiceMailedDate"
                                  data-testid="invoiceMailedDate"
                                  format={dateFormatForDatePicker}
                                  inputFormat={dateFormatForDatePicker}
                                  mask="__/__/____"
                                  minDate={MinDate}
                                  maxDate={MaxDate}
                                  fullWidth
                                  required
                                  placeholder=""
                                  name="invoiceMailedDate"
                                  value={searchRequestMailing.invoiceMailedDate}
                                  onChange={(d) => {
                                    onChangeDateField(d, 'invoiceMailedDate');
                                  }}
                                  onBlur={(e) => {
                                    validateDateFormatOnBlur(
                                      e,
                                      'invoiceMailedDate'
                                    );
                                  }}
                                  onKeyDown={async (e) => {
                                    if (e.keyCode == 67) {
                                      // copy date
                                      await window.navigator?.clipboard.writeText(e?.target?.value);
                                    }
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                  helperText={
                                    showDateError || showError.dateError
                                      ? DATE_INVALID_REQUEST_MAILING
                                      : null
                                  }
                                  error={
                                    showDateError || showError.dateError
                                      ? DATE_INVALID_REQUEST_MAILING
                                      : null
                                  }
                                />
                              </MuiPickersUtilsProvider>
                            </span>
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            )}
            {searchRequestMailing.manufacturer == 'SM' ? (
              <div className="frr-requestmailing-labels panel-body FRR-custom-table tbl-manufacturer-inner">
                <TableGrid
                  gridHeight={fullScreenView ? '70vh' : 400}
                  data-testid="manufacturer-cbi-table"
                  rowData={tableData}
                  columnDefs={columnDefs}
                  rowSelection="multiple"
                  setSelectedRow={setSelectedRow}
                  fullScreenView={fullScreenView}
                  handleFullScreenViewClick={handleFullScreenView}
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  onSelectionChanged={onSelectionChanged}
                  applyFilter={false}
                  fileName="Request Mailing Label"
                  frameworkComponents={frameworkComponents}
                  exportFile
                />
              </div>
            ) : null}
            {!fullScreenView && (
              <div className="col-sm-3 btn-wrapper" style={{ float: 'right' }}>
                <Button
                  className="btn-success same-font-family frr-btn-width-17 mt-2"
                  type="button"
                  style={{ float: 'right' }}
                  onClick={handleProcess}
                  data-testid="handleProcess"
                >
                  <img className="manufactureImg" alt="" src={createIcon} />
                  Process
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default withRouter(RequestInvoiceDetails);
